
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { tryMultipleAssetPaths } from "@/utils/assetUtils";
import { useEffect, useState } from "react";

interface MobileHeaderProps {
  userInitial?: string;
}

const MobileHeader = ({ userInitial = "D" }: MobileHeaderProps) => {
  const [accountIconPath, setAccountIconPath] = useState("");

  useEffect(() => {
    tryMultipleAssetPaths("account_icon.png", (path) => {
      if (path) {
        console.log("✅ Successfully loaded account icon path:", path);
        setAccountIconPath(path);
      } else {
        console.error("Failed to load account icon");
      }
    });
  }, []);

  return (
    <header className="bg-black py-4 px-6 w-full">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/dashboard" className="text-white text-lg font-medium">
          Driver Dashboard
        </Link>
        
        <Link to="/account" className="flex items-center">
          {accountIconPath ? (
            <img 
              src={accountIconPath} 
              alt="Account" 
              className="h-10 w-10"
            />
          ) : (
            <Avatar className="h-10 w-10 bg-neon-green">
              <AvatarFallback className="text-black">{userInitial}</AvatarFallback>
            </Avatar>
          )}
        </Link>
      </div>
    </header>
  );
};

export default MobileHeader;
